import React from "react"
import { type StyleProps } from "@mallardbay/lib-react-components"
import { UnorderedList as UnorderedListOg, ListItem } from "@chakra-ui/react"

interface Props {
    readonly style?: StyleProps
    readonly items: string[]
}

export default function UnorderedList({ style, items }: Props) {
    const styles = useStyles()

    return (
        <UnorderedListOg sx={{ ...styles.root, ...style }}>
            {items.map((item) => (
                <ListItem key={item}>{item}</ListItem>
            ))}
        </UnorderedListOg>
    )
}

function useStyles() {
    const root: StyleProps = {
        paddingLeft: 2,
    }

    return { root }
}
